import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn, buildModuleRoute } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/kudos/pages/RootPage'))

export const kudosRoutes: NavigationRoutesFn = (navigation) => {
  return [
    buildModuleRoute({
      path: navigation.kudos.path,
      element: <RootPage />,
      handle: {
        module: 'kudos',
        moduleName: () => i18n.t('kudos.page_title'),
        meta: () => {
          return {
            title: i18n.t('kudos.page_title'),
            description: i18n.t('kudos.page_description'),
            illustration: 'love-hands',
          }
        },
      },
    }),
  ]
}
